interface FinanceTreeItem {
  id: number;
  serialNumber: string;
  name: string;
  nameAr: string;
  slug: string;
  editable: boolean;
  parentId?: number | null;
  level: number;
  balance: number;
  totalCredit: number;
  totalDebit: number;
  createdAt: string;
  updatedAt: string;
  children?: FinanceTreeItem[];
}

// Helper function to build tree from flat array
export function buildTree(flatArray: FinanceTreeItem[]): FinanceTreeItem[] {
  const map = new Map<number, FinanceTreeItem>();
  const roots: FinanceTreeItem[] = [];

  // First pass: create map
  flatArray.forEach((item) => {
    map.set(item.id, { ...item, children: [] });
  });

  // Second pass: build tree
  flatArray.forEach((item) => {
    const node = map.get(item.id)!;
    if (item.parentId === null || item.parentId === undefined) {
      roots.push(node); // Main level
    } else {
      const parent = map.get(item.parentId);
      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(node); // Sub level
      }
    }
  });

  return roots;
}

// Filter tree data based on search term
export function filterTreeData(
  data: FinanceTreeItem[],
  searchTerm: string,
  currentLang: string
): FinanceTreeItem[] {
  if (!searchTerm) return data;

  const lowerSearchTerm = searchTerm.toLowerCase();

  const filterNode = (node: FinanceTreeItem): FinanceTreeItem | null => {
    const name = currentLang === "ar" ? node.nameAr : node.name;
    const matches =
      name.toLowerCase().includes(lowerSearchTerm) ||
      node.serialNumber.toLowerCase().includes(lowerSearchTerm) ||
      node.slug.toLowerCase().includes(lowerSearchTerm);

    const filteredChildren = node.children
      ? node.children.map(filterNode).filter(Boolean)
      : [];

    if (matches || filteredChildren.length > 0) {
      return {
        ...node,
        children: filteredChildren as FinanceTreeItem[],
      };
    }

    return null;
  };

  return data.map(filterNode).filter(Boolean) as FinanceTreeItem[];
}

